import {
  configGdzSliderWithoutSubject,
  configPopularRecommendSlider,
  gdzSliderClass,
  popularRecommendSliderClass,
} from "./settingSwiperOnMainPage";
import { configRecommendedSlider, recommendedSlider } from "./recommendedSlider";
import initClickSortDropdownListener from "./initClickSortDropdownListener";
import initSwipers from "../swiper/swiperInit";
import scrollTagsInCard from "./scrollTags";

document.addEventListener("DOMContentLoaded", () => {
  initClickSortDropdownListener();
  initSwipers();
  initSwipers(gdzSliderClass, configGdzSliderWithoutSubject);
  initSwipers(popularRecommendSliderClass, configPopularRecommendSlider);
  initSwipers(recommendedSlider, configRecommendedSlider);
  scrollTagsInCard();

  window.addEventListener("resize", () => {
    initSwipers(gdzSliderClass, configGdzSliderWithoutSubject);
    initSwipers(popularRecommendSliderClass, configPopularRecommendSlider);
  });
});
